<template>
  <div class="p-4 rounded-lg shadow-sm bg-white">
    <CommonTable
      :table-data="tableData"
      :name-column-props="{
        prop: 'name',
        label: '地区',
        width: '160px',
      }"
      :fixLength="2"
      :currency="currency"
    />
  </div>
</template>

<style scoped></style>

<script>
import { getTableData } from '../index';
import CommonTable from './CommonTable.vue';
export default {
  name: 'GeographicLocationChart',
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          detailReports: {},
          summaryMetrics: {},
          estimateMetrics: {},
          adGroupMetrics: {},
          currencySign: '$',
        };
      },
    }, // 接收父组件传递的地理位置数据
  },
  components: {
    CommonTable,
  },
  data() {
    return {};
  },
  computed: {
    currency() {
      return this.data?.currencySign || '$';
    },
    tableData() {
      console.log(getTableData(this.data), '111');
      return getTableData(this.data);
    },
  },
};
</script>
